import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CategoryHelper } from '../../../../helper/categoryTransformHelper';
import { CategoryService } from '../../../../service/category.service';
import { SelectModule } from 'primeng/select';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TreeModule } from 'primeng/tree';
import { ChannelService } from '../../../../service/channel.service';
import { TreeSelectModule } from 'primeng/treeselect';
import { UserService } from '../../../../../user/services/user.service';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TippyDirective } from '@ngneat/helipopper';
import { PaginatorModule } from 'primeng/paginator';
@Component({
  selector: 'app-mapping-widget-category',
  standalone: true,
  imports: [
    FormsModule,
    ButtonModule,
    InputTextModule,
    SelectModule,
    DialogModule,
    TranslateModule,
    TreeModule,
    TooltipModule,
    TreeSelectModule,
    AutoCompleteModule,
    TippyDirective,
    PaginatorModule
  ],
  templateUrl: './mapping-widget-category.component.html',
  styleUrl: './mapping-widget-category.component.scss',
})
export class MappingWidgetCategoryComponent implements OnInit {
  @Input() nodes;
  @Input() taxo;
  @Input() associated = false;
  @Input() type;
  @Input() typeMapping;

  categories;
  categoriesFnac;
  showModal = false;
  showRuleModal = false;
  loading: boolean;
  selectedNode = null;
  defaultLocale;
  workingNode;
  conditions = [];
  condition;
  subConditions = ['OR', 'AND'];
  first: number = 0;
  rowsPaginator: number = 10;
  totalRecordsPaginator: number;
  displayedNodes: any[]; 

  constructor(
    private readonly categoryService: CategoryService,
    private readonly translate: TranslateService,
    private readonly channelService: ChannelService,
    private readonly userService: UserService,
  ) {}

  ngOnInit() {
    this.condition = this.initCondition();
    if (this.nodes) {
      for (let node of this.nodes) {
        node.associated = this.associated;
        if (node.mappedTypologies.length > 1) {
          node.choosenTypology = node.mappedTypologies[0];
        }
        for (let typo of node.mappedTypologies) {
          typo.typologyLabel = CategoryHelper.getCategoryById(this.taxo, typo.typology);
        }
      }
    }
    this.conditions = ['importWorkflow.exists', 'importWorkflow.contains'];
    this.totalRecordsPaginator = this.nodes.length
    this.updateDisplayedNodes();
  }

  initCondition() {
    return {
      typology: null,
      rules: [
        {
          id: 0,
          attribute: '',
          value: '',
          type: 'importWorkflow.exists',
          result: null,
          subConditions: [],
        },
      ],
    };
  }

  customTypologySelection(node) {
    this.workingNode = node;
    this.showModal = true;
  }

  confirmNode() {
    if (this.selectedNode) {
      this.showModal = false;
      this.workingNode.mappedTypologies = [
        { typology: this.selectedNode.categoryId, typologyLabel: this.selectedNode.categoryLabelLoc },
      ];
      this.selectedNode = null;
    }
  }

  onSelectedNode(event) {}

  onSelectedNodeDrop(event, node) {
    node.mappedTypologies = [{ typology: event.node.categoryId, typologyLabel: event.node.categoryLabelLoc }];
  }

  assiciate(node) {
    if (node.mappedTypologies.length > 0) {
      if (node.choosenTypology) {
        node.mappedTypologies = [node.choosenTypology];
        delete node.choosenTypology;
      }
      node.associated = true;
    }
  }

  finishMapping() {
    return this.nodes.map((node) => {
      let mappedTypologies = node.mappedTypologies;
      if(node.condition == undefined && mappedTypologies.length > 1) {
        mappedTypologies = [node.mappedTypologies[0]];
      }
      return {
        importId: node.importId,
        status : node.associated ? "Identified" : node.status,
        vendorTypologyCategory: node.vendorTypologyCategory,
        mappedTypologies: mappedTypologies.map((e) => {
          return { typology: e.typology, rule: e.rule ?? null };
        }),
      };
    });
  }

  openRuleModal() {
    this.showRuleModal = true;
    this.condition = this.initCondition();
  }

  removeRule(condition, rule) {
    condition.subConditions = condition.subConditions.filter((r) => r.id !== rule.id);
  }

  changeRuleType(condition) {
    condition.subConditions = [];
  }

  addRule(condition) {
    condition.subConditions.push({
      id: condition.subConditions.length,
      type: 'OR',
      value: '',
    });
  }

  confirmRule() {
    let node = this.nodes.find(
      (node) => node.vendorTypologyCategory == this.condition.typology.vendorTypologyCategory,
    );
    let conditionString = '';
    node.mappedTypologies = [];
    node.condition = structuredClone(this.condition);
    for (let condition of this.condition.rules) {
      let c = { typology: condition.result.categoryId, typologyLabel: condition.result.categoryLabelLoc, rule: '' };
      if (node) {
        conditionString += 'IF '+condition.attribute;
        if (condition.type == 'importWorkflow.contains') {
          conditionString += ` contains '${condition.value}'`;
          for (let sub of condition.subConditions) {
            conditionString += ` ${sub.type} contains '${sub.value}'`;
          }
        } else {
          conditionString += ` exists`;
        }
        conditionString += ` THEN ${condition.result?.categoryId} ELSE `;
        if (conditionString.endsWith('ELSE ')) {
          conditionString = conditionString.slice(0, -5);
        }
        c.rule = conditionString;
        node.mappedTypologies.push(c);
      }
    }
    this.condition = this.initCondition();
    this.showRuleModal = false;
  }

  showRule(node) {
    this.condition = structuredClone(node.condition);
    this.showRuleModal = true;
  }

  addCondition() {
    this.condition.rules.push({
      id: this.condition.rules.length,
      attribute: '',
      value: '',
      type: 'importWorkflow.exists',
      result: null,
      subConditions: [],
    });
  }

  removeCondition(condition) {
    this.condition.rules = this.condition.rules.filter((r) => r.id !== condition.id);
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rowsPaginator = event.rows;
    this.updateDisplayedNodes();
  }

  updateDisplayedNodes() {
    this.displayedNodes = this.nodes.slice(this.first, this.first + this.rowsPaginator);
  }
}
